import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { montarDocumentoPDF, nomeDoArquivo } from "./exportar";
import { logoFortioPDF } from "../../assets/brand/logo-pdf";

/**
 * Fica separado do `exportar.js` por um motivo prático: o bundle do pdfmake é feito para navegador,
 * e o `exportar.js` precisa carregar fora dele para o conteúdo do relatório ser conferido.
 *
 * A escolha do `vfs` é a mesma do `rel-general.js`, que apanhou para chegar nela: dependendo da
 * versão, `pdfFonts` vem embrulhado em `pdfMake` ou vem o vfs cru.
 *
 * Baixa em vez de abrir em aba nova, ao contrário do `rel-general.js`. Medido: com o bloqueador de
 * popup ligado o `.open()` gera o documento inteiro e falha na última linha, e o operador recebe
 * "não foi possível gerar o arquivo" sobre um arquivo que existe. Além disso os três botões ficam
 * lado a lado — dois baixam e um abriria, o que não é o que o clique promete.
 */
export function baixarPDF(relatorio) {
  if (pdfFonts?.pdfMake?.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  } else if (pdfFonts?.["Roboto-Regular.ttf"]) {
    pdfMake.vfs = pdfFonts;
  } else {
    throw new Error("As fontes do pdfmake não carregaram.");
  }

  pdfMake
    .createPdf(montarDocumentoPDF(relatorio, { logo: logoFortioPDF }))
    .download(nomeDoArquivo(relatorio, "pdf"));
}
